module.exports = __webpack_public_path__ + "img/562D2A_2E1615_7E4945_703C3C-256px.4c784726.png";